<template>
  <v-snackbar
    v-model="snackbarData.status"
    :color="snackbarData.type"
    :timeout="2000"
    text
    bottom
    right
  >
    <section class="snackbar__layout">
      <v-icon :class="snackbarConfig.bg" class="mr-3" size="22" color="#FFFFFF">
        {{ snackbarConfig.icon }}
      </v-icon>

      <div>
        <h4>{{ snackbarData.title }}</h4>
        <span>{{ snackbarData.message }}</span>
      </div>
    </section>

    <template v-slot:action="{ attrs }">
      <v-btn color="black" text icon v-bind="attrs" @click="closeSnackbar">
        <v-icon text>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "notificationSnackbar",

  computed: {
    ...mapGetters({
      snackbarData: "getSnackbarData",
    }),

    snackbarConfig() {
      if (this.snackbarData.type === "success") {
        return {
          bg: "snackbar__background-success",
          icon: "mdi-check-circle",
        };
      } else if (this.snackbarData.type === "warning") {
        return {
          bg: "snackbar__background-warning ",
          icon: "mdi-progress-close",
        };
      } else if (this.snackbarData.type === "primary") {
        return {
          bg: "snackbar__background-message ",
          icon: "mdi-message-badge",
        };
      } else if (this.snackbarData.type === "error") {
        return {
          bg: "snackbar__background-error",
          icon: "mdi-progress-close",
        };
      } else {
        return { bg: "", icon: "" };
      }
    },
  },

  methods: {
    ...mapActions(["changeSnackbarData"]),

    closeSnackbar() {
      this.changeSnackbarData([false]);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/_variables.scss";

.v-sheet.v-snack__wrapper:not(.v-sheet--outlined) {
  box-shadow: rgba(126, 126, 126, 0.1) 0px 10px 15px -3px,
    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px !important;
}

.v-snack__wrapper {
  border-radius: 15px !important;
}

.snackbar__layout {
  display: flex !important;
  align-items: center;

  .snackbar__background-error {
    background: $red;
    padding: 10px;
    border-radius: 25px;
  }

  .snackbar__background-success {
    background: $green;
    padding: 10px;
    border-radius: 25px;
  }

  .snackbar__background-warning {
    background: $orange;
    padding: 10px;
    border-radius: 25px;
  }

  .snackbar__background-message {
    background: $blue;
    padding: 10px;
    border-radius: 25px;
  }
}
</style>
